export const message = state => {
  return state.message;
};


